// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	MessageIcon: 'message-icon',
	EmailIcon: 'email-icon',
	PhoneIcon: 'phone-icon',
	LoadingIcon: 'loading-icon',
	ChatLink: 'chat-link',
	EmailLink: 'email-link',
	PhoneLink: 'phone-link',
	ContactLink: 'contact-link',
	LegalLink: 'legal-link',
} as const;
